import React from 'react';
export function ProblemSection() {
  return <section className="w-full py-20 px-6" style={{
    backgroundColor: '#F5F0EB'
  }} data-id="element-169">
      <div className="max-w-3xl mx-auto text-center" data-id="element-170">
        {/* Emoji */}
        <div className="text-6xl mb-6" role="img" aria-label="Luna de noche" data-id="element-171">
          🌙
        </div>

        {/* Headline */}
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-6 leading-tight" style={{
        color: '#1A1A1A',
        fontFamily: 'Plus Jakarta Sans, sans-serif'
      }} data-id="element-172">
          ¿Te ha despertado un huésped a las 3:00 AM?
        </h2>

        {/* Opening hook */}
        <p className="text-lg leading-relaxed mb-8" style={{
        color: '#1A1A1A',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-173">
          ¿Alguna vez te ha despertado un huésped a las 3:00 AM porque no
          encuentra la clave del Wi-Fi o no sabe cómo abrir la puerta? Ser
          anfitrión no debería sentirse como un segundo empleo de guardia 24/7.
          La diferencia entre un anfitrión esclavo de su teléfono y un{' '}
          <strong data-id="element-174">"Superhost"</strong> que genera ingresos pasivos no es la
          propiedad — es el sistema de comunicación.
        </p>

        {/* Divider */}
        <div className="w-16 h-1 rounded-full mx-auto mb-10" style={{
        backgroundColor: '#FF5A5F'
      }} data-id="element-175" />

        {/* The Problem */}
        <div className="text-left bg-white rounded-2xl p-8 shadow-sm border border-[#E8E0D8]" data-id="element-176">
          <h3 className="text-xl font-bold mb-4" style={{
          color: '#1A1A1A',
          fontFamily: 'Plus Jakarta Sans, sans-serif'
        }} data-id="element-177">
            El Modelo de "Reacción" que te tiene esclavizado
          </h3>
          <p className="text-base leading-relaxed mb-6" style={{
          color: '#6B7280',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-178">
            La mayoría de los anfitriones en EE.UU. operan bajo el modelo de
            "Reacción". Esperas a que el huésped tenga un problema para darle
            una solución. Esto te obliga a estar pegado al celular, interrumpe
            tus cenas familiares y genera ansiedad cada vez que recibes una
            notificación.
          </p>
          <p className="text-base leading-relaxed font-medium" style={{
          color: '#1A1A1A',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-179">
            Si no tienes un protocolo de información anticipada, estás a una
            mala experiencia de distancia de una reseña de 3 estrellas que
            arruinará tu posicionamiento en el algoritmo de Airbnb.
          </p>
        </div>

        {/* Why what you tried didn't work */}
        <div className="mt-10 text-left" data-id="element-180">
          <h3 className="text-xl font-bold mb-6 text-center" style={{
          color: '#1A1A1A',
          fontFamily: 'Plus Jakarta Sans, sans-serif'
        }} data-id="element-181">
            ¿Por qué lo que intentaste antes no funcionó?
          </h3>
          <div className="space-y-4" data-id="element-182">
            <div className="flex items-start gap-4 bg-white rounded-xl p-5 shadow-sm border border-[#E8E0D8]" data-id="element-183">
              <span className="text-2xl flex-shrink-0" role="img" aria-label="Cartel" data-id="element-184">
                📋
              </span>
              <p style={{
              color: '#6B7280',
              fontFamily: 'Inter, sans-serif'
            }} className="text-base leading-relaxed" data-id="element-185">
                <strong style={{
                color: '#1A1A1A'
              }} data-id="element-186">
                  Los carteles en la pared
                </strong>{' '}
                suelen ser ignorados por los huéspedes que vienen cansados del
                viaje.
              </p>
            </div>
            <div className="flex items-start gap-4 bg-white rounded-xl p-5 shadow-sm border border-[#E8E0D8]" data-id="element-187">
              <span className="text-2xl flex-shrink-0" role="img" aria-label="WhatsApp" data-id="element-188">
                💬
              </span>
              <p style={{
              color: '#6B7280',
              fontFamily: 'Inter, sans-serif'
            }} className="text-base leading-relaxed" data-id="element-189">
                <strong style={{
                color: '#1A1A1A'
              }} data-id="element-190">
                  Los mensajes largos por WhatsApp
                </strong>{' '}
                se pierden en el historial y se sienten poco profesionales.
              </p>
            </div>
            <div className="flex items-start gap-4 bg-white rounded-xl p-5 shadow-sm border border-[#E8E0D8]" data-id="element-191">
              <span className="text-2xl flex-shrink-0" role="img" aria-label="Descripción" data-id="element-192">
                📄
              </span>
              <p style={{
              color: '#6B7280',
              fontFamily: 'Inter, sans-serif'
            }} className="text-base leading-relaxed" data-id="element-193">
                <strong style={{
                color: '#1A1A1A'
              }} data-id="element-194">
                  Confiar en que el huésped leerá toda la descripción del
                  anuncio
                </strong>{' '}
                es un error que causa el 90% de las fricciones.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}